<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <span dense flat v-if="result == null">
            <v-row v-if="lqfs != null" justify="center">
                <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padding-right-0">
                    <v-chip outlined color="success" class="mr-5">
                        <v-icon>mdi-alarm-check</v-icon>
                        Start Time:{{ lqfs.starttime }}
                    </v-chip>
                </div>
                <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                    <v-chip outlined color="#0f2027" class="mr-5">
                        <v-icon left>mdi-timer-sand</v-icon>
                        <center>
                            {{show_time}} (dd:hh:mm:ss)
                        </center>
                    </v-chip>
                </div>
                <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padding-right-0">
                    <v-chip outlined color="error" class="mr-5">
                        <v-icon>mdi-alarm-check</v-icon>
                        End Time:{{ lqfs.endtime }}
                    </v-chip>
                </div>
                <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padding-right-0">
                    <v-btn rounded color="#F81C41" dark @click="endExam()" small> <v-icon left>mdi-stop-circle-outline</v-icon>End Test </v-btn>
                </div>
            </v-row>
        </span>
        <div class="after-fixed-timer-div" v-if="test_ques_list != null">
            <v-row justify="center" class="mt-5">
                <v-chip class="ma-2" color="theme1" outlined>
                    <v-icon left>mdi-book-open-page-variant</v-icon>
                    {{ current_ques.course_name }}
                    <hr />
                </v-chip>
            </v-row>
            <v-row>
                <v-col xs="12" sm="12" lg="8" xl="8" md="12" cols="12">
                    <v-card class="card-ques" id="style-3" :style="{ height: deviceHeight + 'px' }">
                        <div class="que-display">
                            <span class="que-tag">
                                Question - {{ que_index + 1 }} / {{ test_ques_list.length }} [ Marks - {{ current_ques.que_marks }} ]
                            </span>
                        </div>
                        <!-- <p class="question-text-p qtext" v-html="current_ques.que_text"></p> -->
                        <div class="que">
                            <!-- Question for all type -->
                            <v-row dense>
                                <v-col cols="12" md="5" sm="6">
                            <div class="question-block row ">
                                <span class="question-text" v-html="current_ques.que_text"></span>
                            </div>
                            </v-col>
                            <v-col cols="12" md="7" sm="6">
                            <div class="imgs-question">
                                <span v-if="current_ques.que_file != null">
                                    <!-- <a class="p-2" :href="basepath + current_ques.que_file" target="_blank" >
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-if="current_ques.que_file != null" 
                                                v-bind="attrs" v-on="on"> 
                                                <v-icon color="black">mdi-eye</v-icon></v-btn>
                                            </template>
                                            <span>
                                                View Question File!!! 
                                            </span>
                                        </v-tooltip>
                                    </a> -->

                                    <!-- question image dialog code -->
                                       
                                        <v-dialog
                                                transition="dialog-top-transition"
                                                max-width="600"
                                                
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-if="current_ques.que_file != null" 
                                                v-bind="attrs" v-on="on"> 
                                                <!-- <v-icon color="black">mdi-eye</v-icon> -->
                                            <img :src="basepath + current_ques.que_file" alt="" >

                                                </v-btn>

                                            <!-- <img :src="basepath + current_ques.que_file" alt="" style="height:50px; width:50px;"> -->

                                                </template>
                                                <template v-slot:default="dialog">
                                                <v-card>
                                                    <v-img  :src="basepath + current_ques.que_file">
                                                     </v-img>
                                                    <!-- <pdf src="basepath + current_ques.que_file"></pdf> -->
                                                    <v-card-actions class="justify-end">
                                                    <v-btn
                                                        text
                                                        @click="dialog.value = false"
                                                    >Close2</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                                </template>
                                            </v-dialog>
                                    <!-- question image dialog code end -->

                                    <!-- <img src="basepath + current_ques.que_file" alt="rajj"> -->
                                    <!-- <v-img  :src="basepath + current_ques.que_file">
                                    </v-img> -->
                                </span>
                            </div>
                            </v-col>
                            </v-row>

                            <template v-if="current_ques.que_type == 'MCQ'">
                                <v-card-text>
                                    <p class="options-title-p"><strong>Options</strong></p>
                                    <ol type="A" class="ol">
                                        <li v-for="opt in current_ques.options" :key="opt.op_id">
                                            <v-row>
                                                <input
                                                    type="radio"
                                                    class="radiospace"
                                                    @click="select_opt = opt"
                                                    v-if="current_ques.selected_option != null"
                                                    :name="current_ques.ans_id"
                                                    :checked="current_ques.selected_option.op_id == opt.op_id"
                                                />
                                                <input class="radiospace" type="radio" @click="select_opt = opt" v-else :name="current_ques.ans_id" />
                                                <v-col md="10" sm="10" align="start">
                                                    <!-- shiv code start -->
                                                    <v-row dense>
                                                        <v-col cols="12" md="4" sm="6">
                                                    <span style="opacity: 1;" v-html="opt.option_value"></span><br>
                                                    </v-col>
                                                    <!-- <img class="imgs" :src="basepath + opt.op_file" v-if="opt.op_file != null" @click="zooimg(basepath + opt.op_file)" /> -->
                                                    <v-col cols="12" md="8" sm="6">
                                                    <div style="margin-left:30px">
                                                        <span v-if="opt.op_file != null">
                                                            <!-- <a class="p-2" :href="basepath + opt.op_file" target="_blank" >
                                                                <v-tooltip top>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-btn icon v-if="opt.op_file != null" v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                                                    </template>
                                                                    <span>
                                                                        View Option File!!!
                                                                    </span>
                                                                </v-tooltip>
                                                            </a> -->

                                                            
                                        <!-- <v-col cols="auto"> -->
                                            <v-dialog
                                                transition="dialog-top-transition"
                                                max-width="600"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-if="current_ques.que_file != null" 
                                                v-bind="attrs" v-on="on"> 
                                                <!-- <v-icon color="black">mdi-eye</v-icon> -->
                                                <img :src="basepath + opt.op_file" alt="" style="height:80px; width:90px;">

                                                </v-btn><br><br>

                                            <!-- <img :src="basepath + current_ques.que_file" alt="" style="height:50px; width:50px;"> -->

                                                </template>
                                                <template v-slot:default="dialog">
                                                <v-card>
                                                    <v-img  :src="basepath + opt.op_file">
                                                     </v-img>
                                                    <!-- <pdf src="basepath + current_ques.que_file"></pdf> -->
                                                    <v-card-actions class="justify-end">
                                                    <v-btn
                                                        text
                                                        @click="dialog.value = false"
                                                    >Close2</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                                </template>
                                            </v-dialog>
                                            <!-- </v-col> -->
                                    <!-- shiv code end -->

                                                        </span>
                                                        
                                                    </div>
                                                    </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </li>
                                    </ol>

                                    <!-- template MCQ -->
                                </v-card-text>
                                <br />
                            </template>
                            <template v-if="current_ques.que_type == 'SUBJECTIVE'">
                                <v-card-text class="padding-options">
                                    <v-textarea placeholder="Enter your answers here" persistent-hint outlined v-model="current_ques.answer_text"></v-textarea>
                                   <!-- <div v-for="(file, index) in current_ques.sub_file_list" :key="index">
                                        <v-row class="ml-2" style="margin-bottom: 10px;">
                                            <span style="color: red; font-size: 25px; margin-right: 12px;" class="mdi mdi-delete-circle" @click="deleteFile(file)" :loading="save_load_btn"></span>
                                            <a :href="file.ans_file" target="_blank">F#{{ index + 1 }}</a>
                                        </v-row>
                                    </div> -->
                                    <v-row>
                                        <v-col cols="6" v-if="current_ques.attachment_file_path == null">
                                            <v-file-input
                                                outlined
                                                label="File input"
                                                dense
                                                v-model="current_ques.sub_file_upload"
                                                accept=".*"
                                                :hint="current_ques.sub_file != null ? '' : 'Please Select File'"
                                                persistent-hint
                                                show-size
                                                prepend-icon="mdi-paperclip"
                                            ></v-file-input>
                                        </v-col>
                                        <v-col cols="6" v-else>
                                            <span v-if="current_ques.attachment_file_path != null">
                                                <a class="p-2" :href="basepath + current_ques.attachment_file_path + current_ques.attachment_file_name" target="_blank">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon v-if="current_ques.attachment_file_path != null" v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                                        </template>
                                                        <span>
                                                            View submitted File!!!
                                                        </span>
                                                    </v-tooltip>
                                                </a>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon color="red" @click="deletedialog_question(current_ques.ans_id)" v-bind="attrs" v-on="on">mdi-delete-circle</v-icon>
                                                    </template>
                                                    <span>
                                                        Delete submitted File!!!
                                                    </span>
                                                </v-tooltip>
                                            </span>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </template>
                        </div>
                    </v-card>
                    <div class="nav-btn">
                        <v-btn class="sub-btn btn-grad" rounded :loading="save_load_btn" @click="getPrevious" v-if="que_index !== 0">Previous</v-btn>
                       <!--  <v-btn rounded class="btn-grad1" :loading="save_load_btn" @click="saveOption('ANSWERED',current_ques.que_type)">Save</v-btn> -->
                       <v-btn rounded class="btn-grad1" :loading="save_load_btn" @click="locatorButtonPressed('ANSWERED',current_ques.que_type)">Save</v-btn>
                        <!-- <v-btn :loading="save_load_btn" rounded class="sub-btn review-btn" @click="saveAnswer('REVIEW')">Save & Review</v-btn>&nbsp;&nbsp; -->
                        <v-btn rounded :loading="save_load_btn" outlined class="btn-grad3" @click="getNext" v-if="!(que_index == test_ques_list.length - 1)">Next</v-btn>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" lg="4" xl="4" md="12" cols="12" class="overview-row">
                    <v-card class="overview-card" :style="{ height: deviceHeight + 'px' }">
                        <div class="que-display">
                            <span class="que-tag">Questions Overview</span>
                        </div>

                        <v-btn
                            rounded
                            class="mr-2 mt-2 btn-exam"
                            :loading="save_load_btn"
                            @click="getQues(ques, index)"
                            :style="{
                                      'background-color': ques.btn_color,
                                      'border-style':que_index == index?'solid':'',
                                      'border-color':que_index == index?'white':'',
                                      'border-radius':que_index == index?'300px':''
                                    }"
                            v-for="(ques, index) in test_ques_list"
                            :key="ques.ans_id"
                        >
                            <template v-if="que_index == index">
                                <i>
                                    <u>{{ index + 1 }}</u>
                                </i>
                            </template>
                            <template v-else>{{ index + 1 }}</template>
                        </v-btn>
                    </v-card>
                </v-col>
            </v-row>
        </div>
        <v-dialog v-model="dialog_delete_option1" persistent max-width="500px">
            <v-card>
                <v-container>
                <v-card class="box">
                    <input type="hidden" v-model="deleteItem_opt1.delete_id1" />
                    <strong>Are you sure you want Delete this file???</strong>
                    <v-row justify="center">
                    <v-btn class="button" text @click="dialog_delete_option1 = false">No</v-btn>
                    <v-btn class="button" text @click="deletefile()">Yes</v-btn>
                    </v-row>
                </v-card>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog v-model="end_dialog" persistent max-width="500px">
            <v-card>
                <v-container>
                <v-card class="box">
                    <strong>Are you sure you want to end exam ??</strong>
                    <v-row justify="center">
                    <v-btn class="button" text @click="end_dialog = false">No</v-btn>
                    <v-btn class="button" text @click="exitExam()">Yes</v-btn>
                    </v-row>
                </v-card>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import { VueMathjax } from "vue-mathjax";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        components: {
            "vue-mathjax": VueMathjax,
            // TabSwitch,
        },
        name: "Timer",
        data: () => ({
            dialog_zooimg: false,
            img_url: null,
            test_ques_list: null,
            lqfs: null,
            current_ques: null,
            select_opt: null,
            basepath: null,
            que_index: 0,
            result: null,
            //load
            save_load_btn: false,
            formattedNumber: "",
            //new code
            totalsec: 0,
            show_time: "",
            tim: null,
            snackbar_msg: null,
            color: null,
            snackbar: false,
            deviceHeight: "",
            snack_height: "",
            dialog_delete_option1:false,
            end_dialog:false,
            longitude:null,
            latitude:null,
            deleteItem_opt1: {
                delete_id1: "",
                type: "",
            },
        }),
        updated: function () {
            //console.log("Inside updated");
            this.$nextTick().then(() => {
                if (window.MathJax) {
                    // console.log("rendering mathjax");
                    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log(""));
                }
            });
        },
        computed: {
            end_time() {
                return this.lqfs.endtime;
            },
        },
        created() {
            if (this.$session.has("test_ques_list")) {
                this.test_ques_list = JSON.parse(this.$session.get("test_ques_list"));
                this.current_ques = this.test_ques_list[0];
                this.select_opt = this.current_ques.selected_option;
                this.lqfs = JSON.parse(this.$session.get("lqfs"));
                this.basepath = JSON.parse(this.$session.get("path"));
               
            } else {
                this.showSnackbar("#b71c1c", "Test Ended");
                // this.$router.push({ name: "my-courses" });
            }
        },
        mounted() {
            this.deviceHeight = window.innerHeight - 160;
            this.snack_height = this.deviceHeight / 2;
            if (window.MathJax) {
                //console.log("rendering mathjax");
                window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
            }
            if (this.lqfs == null) {
                return;
            }
            if (this.lqfs.end_timer != null) {
                const formData = {
                    lqfsid: this.lqfs.lqfsid,
                };
                //
                axios
                    .post("/LearnerQuiz/getEndTime", formData)
                    .then((res) => {
                        //this.lqfs = res.data.lqfs;
                        if (res.data.end_exam == "YES") {
                            this.exitExam();
                            return;
                        }
                        this.totalsec = res.data.end_timer;
                        // console.log("b4 start:"+this.totalsec)
                        if (this.totalsec > 0) {
                            this.tim = setInterval(() => {
                                this.showtime();
                            }, 1000);
                        }
                    })
                    .catch((error) => {
                        // show snackbar
                    })
                    .finally(() => {
                        this.save_load_btn = false;
                    });
                //
            }
        },
        methods: {
            deletedialog_question(item){
                this.dialog_delete_option1 = true;
                this.deleteItem_opt1.delete_id1 = item;
            },
            deletefile(){
                 const data = {
                    id : this.deleteItem_opt1.delete_id1,
                    lqfsid : this.lqfs.lqfsid
                }
                axios
                    .post("/LearnerQuiz/deletefile", data)
                    .then((res) => {
                     if (res.data.flag == "YES") {
                           this.dialog_delete_option1 = false;
                           
                            this.answerResponse(res);
                        } else {
                             this.showSnackbar("#b71c1c", "Something went wrong !!!");
                             this.dialog_delete_option1 = false;
                        }
                    })
                    .catch((error) => {
                         this.showSnackbar("#b71c1c", "Something went wrong !!!");
                         this.dialog_delete_option1 = false;
                    })
                    .finally(() => {
                        this.dialog_delete_option1 = false;
                    });
            },
            answerResponse(res){
                 console.log("res------", res);
                    if (res.data.end_timer != null) {
                        this.totalsec = res.data.end_timer;
                    }
                    this.lqfs = res.data.lqfs;
                    this.current_ques = res.data.current_ques;
                    this.select_opt = this.current_ques.selected_option;
                    Object.assign(this.test_ques_list[this.que_index], this.current_ques);
                    this.$session.set("test_ques_list", JSON.stringify(res.data.test_ques_list));
                    this.$session.set("lqfs", JSON.stringify(res.data.lqfs));
                    this.showSnackbar("#4caf50", res.data.snackbar);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onFocus() {
                console.log("in onFocus");
            },
            sformat(s) {
                var fm = [
                    Math.floor(Math.floor(Math.floor(s / 60) / 60) / 24) % 24, //DAYS
                    Math.floor(Math.floor(s / 60) / 60) % 60, //HOURS
                    Math.floor(s / 60) % 60, //MINUTES
                    s % 60, //SECONDS
                ];
                return $.map(fm, function (v, i) {
                    return (v < 10 ? "0" : "") + v;
                }).join(":");
            },
            showtime() {
                //console.log("showtime");
                // 1 seconde eraf
                this.totalsec--;
                this.show_time = this.sformat(this.totalsec);
                if (this.totalsec == 0) {
                    clearInterval(this.tim);
                    //console.log("Exam ended...")
                    this.exitExam();
                }
            },
            goHome() {
                //  this.$router.push({ name: "my-courses" });
            },
            zooimg(url_img) {
                //alert("zooimg"+url_img)
                this.img_url = url_img;
                this.dialog_zooimg = true;
            },
            endExam(){
                this.end_dialog = true
            },
            exitExam() {
                axios
                    .post("/LearnerQuiz/calculateResult", { lqfsid: this.lqfs.lqfsid })
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.$session.remove("test_ques_list");
                            this.showSnackbar("#4caf50", "Submitted Successfully");
                            this.end_dialog = false
                            this.$router.push({ name: "learner-quiz" });
                        } else {
                             this.end_dialog = false
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                        }
                    })
                    .catch((error) => {
                             this.end_dialog = false
                               this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.overlay = false;
                         this.end_dialog = false
                    });
            },
            startCallBack: function (x) {
                //console.log(x);
            },
            endCallBack: function (x) {
                //console.log("auto end");
                this.exitExam();
                //alert(x)
            }, //end

            locatorButtonPressed(type, que_type) {
            this.loader = true;
            let obj = this
            //console.log('obj', obj)
            if(navigator.geolocation){
                navigator.geolocation.getCurrentPosition(position => {
                    console.log("latitude")
                    obj.latitude = position.coords.latitude
                    obj.longitude = position.coords.longitude
                    console.log(position.coords.latitude);
                     console.log("longitude")
                    console.log(position.coords.longitude);
                    obj.saveOption(type, que_type)
                },
                error =>{
                    console.log(error.message)
                    obj.saveOption(type, que_type)
                }
                );         
            }
            else{
                console.log("Geolocation is not supported by this browser")
                obj.saveOption(type, que_type)
            }
        }, 
            saveOption(type, que_type) {
                // alert(que_type)
                //alert(this.current_ques.answer_text)
                if (que_type == "MCQ") {
                    if (typeof this.select_opt.op_id === "undefined") {
                        this.showSnackbar("#b71c1c", "Please select option.");
                        return;
                    }
                } else if (que_type == "SUBJECTIVE") {
                    if (this.current_ques.answer_text == null && this.current_ques.sub_file_upload == null) {
                        this.showSnackbar("#b71c1c", "Please Enter answer or upload file!!!");
                        return;
                    }
                }
                //call api
                let formData = new FormData();
                formData.append("longitude",this.longitude);
                formData.append("latitude", this.latitude);
                formData.append("lqfsid", this.lqfs.lqfsid);
                formData.append("current_ques_id", this.current_ques.ans_id);
                if (que_type == "SUBJECTIVE") {
                    formData.append("subj_ans", this.current_ques.answer_text);
                    formData.append("files", this.current_ques.sub_file_upload);
                    console.log("files", this.current_ques.sub_file_upload);
                }
                formData.append("type", type);
                formData.append("que_type", que_type);
                if (que_type == "MCQ") {
                    formData.append("select_opt_id", this.select_opt.op_id);
                }
                this.save_load_btn = true
                axios
                    .post("/LearnerQuiz/saveOption", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            if (res.data.end_timer != null) {
                                this.totalsec = res.data.end_timer;
                            }
                            this.lqfs = res.data.lqfs;
                            this.current_ques = res.data.current_ques;
                            this.select_opt = this.current_ques.selected_option;
                            Object.assign(this.test_ques_list[this.que_index], this.current_ques);
                            this.$session.set("test_ques_list", JSON.stringify(res.data.test_ques_list));
                            this.$session.set("lqfs", JSON.stringify(res.data.lqfs));
                            this.showSnackbar("#4caf50", res.data.snackbar);
                            this.save_load_btn = false
                            if (this.que_index + 1 < this.test_ques_list.length) this.getNext();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            if (res.data.end_exam == "YES") {
                                this.exitExam();
                            } else if (res.data.end_exam == "YES") {
                                //should not occur
                                this.exitExam();
                            }
                        }
                    })
                    .catch((error) => {
                        // show snackbar
                         this.save_load_btn = false
                    })
                    .finally(() => {
                        this.save_load_btn = false;
                    });
            },
            getNext() {
                // this.que_index = this.que_index+1
                this.current_ques = this.test_ques_list[++this.que_index];
                this.select_opt = this.current_ques.selected_option;
            },
            getPrevious() {
                this.current_ques = this.test_ques_list[--this.que_index];
                this.select_opt = this.current_ques.selected_option;
            },
            getQues(ques, index) {
                this.current_ques = ques;
                this.que_index = index;
                this.select_opt = this.current_ques.selected_option;
            },
        },
        computed: {
            graphBar() {
                var number = (this.result.actualmarks / this.result.total) * 100;
                return number.toFixed(2);
            },
        },
        beforeDestroy() {
            //console.log("destroy")
            clearInterval(this.tim);
        },
    };
</script>
<style scoped>
    .after-fixed-timer-div {
        position: relative;
    }
    overview-row {
        padding: 0px;
        padding-top: 12px;
    }

    .overview-card {
        /* height: 504px; */
        overflow-y: scroll;
    }
    .que-display {
        /* background: #00E5FF !important; */
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        padding: 0.8rem !important;
        /* border: 3px solid #607d8b; */
    }

    .que-tag {
        color: white !important;
        font-size: 18px;
        font-weight: bold;
    }
    .question-heading-p,
    .marks-p,
    .options-title-p {
        font-size: 16px;
    }
    .btn-exam {
        color: white;
        font-weight: bold;
    }

    .que {
        /* height: 450px; */
        overflow-y: auto;
        overflow-x: hidden;
        margin-top: 5px;
    }
    .question-block {
        /* border: 1.7px solid #424093; */
        margin-left: 1rem;
        padding-left: 22px;
        border-radius: 6px;
    }
    .question-text {
        padding: 0px !important;
        /* margin-left: 19px; */
        font-weight: bold;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .span-mr {
        margin: 0.7rem !important;
    }
    .nav-btn {
        text-align: center;
        padding: 10px;
    }
    .btn-end-exam1 {
        border: 2px solid darkorange !important;
        color: darkorange;
        font-weight: bold;
        background: transparent !important;
    }
    .btn-end-exam1:hover {
        color: white;
        background: darkorange !important;
    }
    .imgs-question {
        margin-left: 2.6rem !important;
    }
    .btn-grad {
        background-image: linear-gradient(to right, #757f9a 0%, #d7dde8 51%, #757f9a 100%);
    }
    .btn-grad {
        margin-right: 1rem !important;
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: white;
        box-shadow: 0 0 20px #eee;
    }

    .btn-grad:hover {
        background-position: right center; /* change the direction of the change here */
        color: #fff;
        text-decoration: none;
    }

    .btn-grad1 {
        background-image: linear-gradient(to right, #000000 0%, #53346d 51%, #000000 100%);
    }
    .btn-grad1 {
        margin-right: 1rem !important;
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: white;
        box-shadow: 0 0 20px #eee;
    }

    .btn-grad1:hover {
        background-position: right center; /* change the direction of the change here */
        color: #fff;
        text-decoration: none;
    }
    .btn-grad3 {
        background-image: linear-gradient(to right, #fe8c00 0%, #f83600 51%, #fe8c00 100%);
    }
    .btn-grad3 {
        margin-right: 1rem !important;
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: white;
        box-shadow: 0 0 20px #eee;
    }

    .btn-grad3:hover {
        background-position: right center; /* change the direction of the change here */
        color: #fff;
        text-decoration: none;
    }

    .btn-grad4 {
        background-image: linear-gradient(to right, #cacadb);
    }

   .imgs-question img{ 
       height:80px; 
       width:90px;
       /* margin-top: 10px; */
       margin-left: 3%;
       
    }
</style>
